<template>
  <div class="contact-wrapper site-width">
    <div class="contact-icons">
      <a href="https://www.linkedin.com/in/naomi-mine/" target="_blank"
        ><svgicon icon="linkedin" width="40px" height="40px"></svgicon
      ></a>
      <a href="https://www.instagram.com/naomi.mine/" target="_blank"
        ><svgicon icon="instagram" height="48"></svgicon
      ></a>
      <!-- <a href="mailto:naomi.mine@gmail.com" target="_blank"
        ><svgicon icon="gmail" height="36"></svgicon
      ></a> -->
    </div>
    <div class="contact-links-text">
    <div class="contact-website"><a href="https://ischool.wisc.edu/blog/staff/mine-naomi/">ischool.wisc.edu/blog/staff/mine-naomi/</a></div>
    <div class="contact-email-address">naomi {dot} mine {at} gmail {dot} com</div>
    </div>
  </div>
</template>

<script>
import "../compiled-icons/index";
export default {
  name: "Contact",
};
</script>

<style lang="sass-loader">
@import "../assets/styles/main.scss";
.contact {
  &-wrapper {
    margin: 20px auto;
  }
  &-links-text {
    font-size: 20px;
  }
  &-icons {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  &-website {
    text-decoration: underline;
    margin-bottom: 10px;
  }
  @include breakpoint(tablet-landscape) {
    &-wrapper {
      text-align: center;
    }
    &-icons {
      justify-content: center;
    }
  }
}
a {
  margin-right: 14px;
}
svg {
  fill: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue